import React, { Suspense } from 'react';
import ErrorBoundary from '../../components/error-boundary';
// Imports Components
import Loading from '../../components/loading/loading';
import { lazyWithRetry } from '../../components/lazyLoading/index.js';
// Lazy Components
const ResetPasswordLazy = lazyWithRetry(() => import('./index.jsx'));

const ResetPassword = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading />}>
        <ResetPasswordLazy />
      </Suspense>
    </ErrorBoundary>
  );
};
export default ResetPassword;
